<div class="add-bid-card">
    <form [formGroup]="addBidInstructionForm" (ngSubmit)="submitInstructionForm()" class="add-bid-form">
        <div class="form-group">
            <div class="ui-grid-row form-field-label">
                <div class="ui-grid-col-12">
                <label for="State">Property State <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center"> 
                    <p-dropdown #selectState  [options]="states" 
                        formControlName="State" 
                        [placeholder]="statePlaceholder" 
                        (onChange)="getAvailableTrustees($event.value)"
                        styleClass="add-bid-dropdown"
                        filter="true" 
                        filterBy="label,value">                        
                    </p-dropdown>
                </div>
            </div>

            <div class="ui-grid-row form-field-label">
                <div class="ui-grid-col-12">
                <label for="TrusteeName">Trustee Name <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center">
                    <p-dropdown [options]="trustees" 
                        formControlName="Trustee" 
                        filter="true" 
                        [placeholder]="trusteePlaceholder" 
                        dataKey="TrusteeId" 
                        optionLabel="TrusteeName"
                        styleClass="add-bid-dropdown">                        
                    </p-dropdown>
                    <span *ngIf="trusteeControl.touched && trustees.length == 0" class="custom-error">Please select state and then select trustee.</span>
                </div>                
            </div>

            <div class="ui-grid-row form-field-label">
                <div class="ui-grid-col-12">
                <label for="BiddingInstructionsDocumentIncluded">Bidding Instructions Document Included? <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center">
                    <div class="ui-g-12" style="display: flex;">
                        <p-radioButton name="BidInstrDocIncluded" formControlName="BidInstrDocIncluded" class="radio-margin" value="1" label="Yes"></p-radioButton>
                        <p-radioButton name="BidInstrDocIncluded" formControlName="BidInstrDocIncluded" value="0" label="No"></p-radioButton>
                    </div>
                </div>
            </div>

            <div class="ui-grid-row form-field-label">
                <div class="ui-grid-col-12">
                <label for="SaleCertfAltisourceCopyIncluded">Certificate Of Sale - Altisource Copy Included? <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center">
                    <div class="ui-g-12" style="display: flex;">
                        <p-radioButton name="SaleCertfAltisourceCopyIncluded" formControlName="SaleCertfAltisourceCopyIncluded" class="radio-margin" value="1" label="Yes"></p-radioButton>
                        <p-radioButton name="SaleCertfAltisourceCopyIncluded" formControlName="SaleCertfAltisourceCopyIncluded" value="0" label="No"></p-radioButton>
                    </div>
                </div>
            </div>

            <div class="ui-grid-row form-field-label">
                <div class="ui-grid-col-12">
                <label for="SaleCertfBuyerCopyIncluded">Certificate Of Sale - Buyer's Copy Included? <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center">
                    <div class="ui-g-12" style="display: flex;">
                        <p-radioButton name="SaleCertfBuyerCopyIncluded" formControlName="SaleCertfBuyerCopyIncluded" class="radio-margin" value="1" label="Yes"></p-radioButton>
                        <p-radioButton name="SaleCertfBuyerCopyIncluded" formControlName="SaleCertfBuyerCopyIncluded" value="0" label="No"></p-radioButton>
                    </div>
                </div>
            </div>

            <div class="ui-grid-row form-field-label">
                <div class="ui-grid-col-12">
                <label for="AltisourceBidSheetIncluded">Altisource Bid Sheet Included? <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center">
                    <div class="ui-g-12" style="display: flex;">
                        <p-radioButton name="AltisourceBidSheetIncluded" formControlName="AltisourceBidSheetIncluded" class="radio-margin" value="1" label="Yes"></p-radioButton>
                        <p-radioButton name="AltisourceBidSheetIncluded" formControlName="AltisourceBidSheetIncluded" value="0" label="No"></p-radioButton>
                    </div>
                </div>
            </div>

            <div class="ui-grid-row form-field-label-upload">
                <div class="ui-grid-col-12">
                <label for="BiddingInstructionsDocumentIncluded">Bid Instructions <span class="custom-required">*</span></label>
                </div>
            </div>
            <div class="ui-grid-row form-field">
                <div class="ui-grid-col-12 vert-center">
                    <div class="upload-div">
                        <p-fileUpload #fileUpload mode="basic" name="bidInstructions" 
                            customUpload="true" accept=".docx" maxFileSize="1000000" 
                            (onSelect)="onUpload($event)" *ngIf="uploadedFiles.length == 0">            
                        </p-fileUpload>
                        <div *ngIf="uploadedFiles.length" style="display: flex;">
                        <div #fileDetail class="file-detail">
                            <span *ngFor="let file of uploadedFiles">
                                <i class="far fa-file-word"></i>{{file.name}} - {{file.size}} bytes
                            </span>
                        </div>   
                        <a href="##" class="trash-icon" (click)="clearUploadedFile()"><i class="far fa-trash-alt"></i></a>  
                        </div>          
                    </div>                    
                </div>
                <div class="uploaded-file">
                    <span>
                        <a href="##" (click)="downloadBidInstructionFile()"><i class="far fa-file-word"></i> {{bidInstructionFilename}}</a>
                    </span>
                </div>
            </div>

            <div class="add-bid-button-block">
                <button pButton type="button" 
                    label="{{processing ? 'Saving..' : 'Cancel'}}" 
                    class="ui-button-secondary add-bid-button" 
                    (click)="hideAddBidForm()">
                </button>
                <button pButton type="submit" 
                    label="{{processing ? 'Saving..' : 'Create Bid Instruction'}}" 
                    class="add-bid-button" 
                    [disabled]="processing || addBidInstructionForm.invalid || uploadedFileName == ''">
                </button>
            </div>
        </div>
    </form>    
</div><br/>